import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { AnalyticsService } from "../../../../../services/analytics.service";
import { AnalyticsAction, AnalyticsModule } from "../../../../../services/analytics.types";
import { DialogSls } from "../../../../dialogs/dialog-sls/dialog-sls";

@Component({
  selector: "availability-item",
  templateUrl: "availability-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class AvailabilityItem {
  private dialog = inject(MatDialog);
  private analytics = inject(AnalyticsService);

  protected subscription = input.required();

  showSlsDialog() {
    this.analytics.trackFeature(AnalyticsModule.Network, AnalyticsAction.SlsRetrieval);
    this.dialog.open(DialogSls, {
      data: this.subscription(),
    });
  }
}
